import { useMemo } from 'react';
import FilterDropdown from 'components/elements/Dropdown/FilterDropdown';
import { useAvailableCities } from 'hooks/useUserCityAccess';
import { useRegionFilter, useStateDocFilter } from 'state/filterDocuments';
import { METROPOLITAN_CODE_TO_LABEL, Region } from 'utils/constants/location';

const LocationFilter = () => {
  const { regionFilter, setRegionFilter } = useRegionFilter();
  const { stateFilter } = useStateDocFilter();
  const { availableStates, availableRegions } = useAvailableCities();

  const regionOptions = useMemo(() => {
    const regionKeys =
      stateFilter && availableStates[stateFilter]
        ? Object.keys(availableStates[stateFilter].regions)
        : Object.keys(availableRegions);

    return regionKeys.map((key) => ({
      value: key,
      label: METROPOLITAN_CODE_TO_LABEL[key] || key,
    }));
  }, [stateFilter, availableStates, availableRegions]);

  const handleChange = (values: string[]) => {
    setRegionFilter(values as Region[]);
  };

  return (
    <FilterDropdown
      options={regionOptions}
      checkedValues={regionFilter}
      setCheckedValues={handleChange}
      maxHeight="280px"
    >
      Region
    </FilterDropdown>
  );
};

export default LocationFilter;
